import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { truncate } from 'lodash';
import useMediaQuery from 'react-use-media-query-hook';

import Card from '../../main/containers/channel/CardBlogArch';
import { BLOG_FRIENDLY_TEMPLATE_NAME } from '../../main/utils/const';
import SectionHeaderWeb from '../../main/components/SectionHeaderWeb';
import { getColorDependsOnBackground } from '../../main/utils/helpers/getColorDependsOnBackground';

const Channels = ({
  locales,
  locales: {
    portfolioWeb,
    channel: {
      intro: { card },
    },
  },
  backgroundSection,
  thirdColor,
  isFourthColorPaletteNumber = false,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [activeCardId, setActiveCardId] = useState(null);
  const { channels } = useSelector((state) => state.portfolio);
  const { collection } = useSelector((state) => state.channel);

  const activeCardData = useMemo(() => {
    if (collection.length && !activeCardId) {
      setActiveCardId(collection[0].id);
      return collection[0];
    }
    return collection.find((i) => i.id === activeCardId);
  }, [collection, activeCardId]);

  const textColorDependsOnBackground =
    isFourthColorPaletteNumber &&
    getColorDependsOnBackground(backgroundSection);

  const buttonTextColorDependsOnBackground =
    isFourthColorPaletteNumber && getColorDependsOnBackground(thirdColor);

  const singleCard = activeCardData && (
    <Card
      locales={locales}
      isPreview
      background={backgroundSection}
      backgroundImage={backgroundSection}
      textColor={textColorDependsOnBackground}
      textColorDependsOnBackground={textColorDependsOnBackground}
      borderImageColor={textColorDependsOnBackground}
      templateName={BLOG_FRIENDLY_TEMPLATE_NAME}
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  return (
    <div
      className="channel-blogFriendly-web section-web"
      style={{ backgroundColor: backgroundSection }}
    >
      <SectionHeaderWeb
        templateName={BLOG_FRIENDLY_TEMPLATE_NAME}
        title={portfolioWeb.channels}
        description={channels.description}
        portfolioWeb={portfolioWeb}
        style={{ color: textColorDependsOnBackground }}
        descriptionColor={textColorDependsOnBackground}
      />

      <div className="cards-section">
        <div className="left">
          {isMobile
            ? collection.map((channel) => {
                return (
                  <Card
                    locales={locales}
                    className="margin-top-20"
                    isPreview
                    background={backgroundSection}
                    backgroundImage={backgroundSection}
                    textColor={textColorDependsOnBackground}
                    textImageColor={textColorDependsOnBackground}
                    borderImageColor={textColorDependsOnBackground}
                    templateName={BLOG_FRIENDLY_TEMPLATE_NAME}
                    card={{
                      ...card,
                      ...channel,
                      title: null,
                    }}
                  />
                );
              })
            : singleCard}
        </div>
        <div className="right">
          {collection.map(({ id, name }) => (
            <div
              key={id}
              onClick={() => setActiveCardId(id)}
              className={classnames('item', 'custom-font-body', {
                active: activeCardId === id,
              })}
              style={{
                backgroundColor: activeCardId === id && thirdColor,
                color:
                  activeCardId === id
                    ? buttonTextColorDependsOnBackground
                    : textColorDependsOnBackground,
                borderColor: textColorDependsOnBackground,
              }}
            >
              {truncate(name, { length: 30 })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Channels;
